import { primaryRegularFont, primarySemiBoldFont, theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { responsiveText, spacing } = theme;

export const deliveryBlock = css`
  ${primaryRegularFont};

  header {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto;
    row-gap: ${spacing.xs}px;
  }

  h2 {
    margin: 0;
    ${responsiveText.HEADING.SM};
  }

  hr {
    margin: ${spacing.md}px 0;
    border: 0;
    height: 1px;
    color: var(--brand-purple-70);
    background-color: var(--brand-purple-70);
  }
`;

export const countrySelect = css`
  margin: ${spacing.base}px 0 ${spacing.xs}px;

  select {
    padding: 2px 6px;
    border: none;
    background-color: var(--neutral-black-10);
    ${responsiveText.BODY.XS};
  }
`;

export const timezoneMessageWrapper = css`
  grid-column: span 2;

  display: grid;
  grid-template-columns: auto 1fr;
  margin-bottom: ${spacing.md}px;

  & > span {
    margin-top: 1px;
    align-self: start;
  }
`;

export const timezoneMessage = css`
  ${responsiveText.BODY.XS};

  margin: 0 0 0 ${spacing.base}px;
`;

export const deliveryNotAvailableMessage = css`
  margin: 0;
  padding: 0;
  ${primarySemiBoldFont}
`;
